__webpack_require__.p = "/acquisition-posting-details-modal/referrals-hub/";